import React from "react";
import './Buttons.scss';

type ButtonProps = {
  children?: React.ReactNode;
  title?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  iconPosition?: 'start' | 'end';
  size?: 'default' | 'compact';
};

export const PrimaryButton = (props: ButtonProps) => {
  return (
    <div className={`v3-primary-button ${props.className} ${props.disabled ? 'disabled' : ''}`} onClick={() => props.onClick && props.onClick()} style={props.style}>
      {props.iconPosition === 'start' && props.children}
      {props.title && <div className="title">{props.title}</div>}
      {props.iconPosition !== 'start' && props.children}
    </div>
  );
}

export const DangerButton = (props: ButtonProps) => {
  return (
    <div className={`v3-danger-button ${props.className} ${props.disabled ? 'disabled' : ''}`} onClick={() => props.onClick && props.onClick()} style={props.style}>
      {props.title && <div className="title">{props.title}</div>}
      {props.children}
    </div>
  );
}

export const SecondaryButton = (props: ButtonProps) => {
  return (
    <div className={`v3-secondary-button ${props.className} ${props.disabled ? 'disabled' : ''}`} onClick={() => props.onClick && props.onClick()} style={props.style}>
      {props.title && <div className="title">{props.title}</div>}
      {props.children}
    </div>
  );
}

export const LinkButton = (props: ButtonProps) => {
  return (
    <button
      className={`v3-link-button ${props.className ?? ''}`}
      onClick={props.onClick}
      disabled={props.disabled}
      style={props.style}
      type="button"
    >
      {props.children ?? props.title}
    </button>
  );
}

export const TertiaryButton = (props: ButtonProps) => {
  const sizeClass = props.size === 'compact' ? 'compact' : '';
  return (
    <div className={`v3-tertiary-button ${sizeClass} ${props.className ?? ''} ${props.disabled ? 'disabled' : ''}`} onClick={() => props.onClick && props.onClick()} style={props.style}>
      {props.iconPosition === 'start' && props.children}
      {props.title && <div className="title">{props.title}</div>}
      {props.iconPosition !== 'start' && props.children}
    </div>
  );
}